// extracted by mini-css-extract-plugin
export var blue = "_m-f";
export var brand = "_m-b";
export var darkGrey = "_m-e";
export var disabled = "_m-4";
export var disabledSubtle = "_m-5";
export var error = "_m-6";
export var green = "_m-g";
export var grey = "_m-d";
export var icon = "_m-0";
export var inherit = "_m-a";
export var lightGrey = "_m-c";
export var orange = "_m-i";
export var pink = "_m-k";
export var primary = "_m-1";
export var purple = "_m-l";
export var red = "_m-j";
export var secondary = "_m-2";
export var success = "_m-9";
export var tertiary = "_m-3";
export var warning = "_m-7";
export var warningSecondary = "_m-8";
export var white = "_m-m";
export var yellow = "_m-h";